<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				 <el-breadcrumb-item :to="{ path: '/serviceHome/serviceOrder/orderDatails?o_id='+oid}">我的订单</el-breadcrumb-item>
				  <el-breadcrumb-item>评审详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button" @click="fanhui" style="cursor:pointer;">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<div class="submit">
				<h4>评审材料</h4>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
					<el-form-item label="详细描述" prop="description">
					  <el-input  :autosize="{ minRows: 5, maxRows: 8}" type="textarea" v-model="ruleForm.description"></el-input>
					</el-form-item>
					<el-form-item label="附件上传" prop="file" required>
					   <el-upload
						 class="upload-demo"
						 :action="uploadActionUrl"
						 :on-remove="handleRemove"
						 :on-success="handleUploadSuccess"
						 :before-remove="beforeRemove"
						 :multiple='false'
						 :limit="4"
						 :on-exceed="handleExceed"
						 :file-list="fileList">
						 <div>
							<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
							<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
								单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf 文件类型
							</span>
						 </div>
					   </el-upload>
					</el-form-item>
					<div class="fbfooter">
						 <div class="fbfooter1" @click="quxiao">取消</div> 
						 <div class="fbfooter2" @click="submitForm('ruleForm')">立即提交</div>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	 import config from '@/config/index'
	import {
		defenseOrId
	} from "@/api/api.js";
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
			baseURL:config.baseURL,
			ruleForm:{
				  description:"",
				  file:[]
			},
			rules: {
				description: [
				  { required: true, message: '请输入详细描述', trigger: 'blur' },
				],
				file: [
					{
						validator: (rule, value, callback) => {
							if (Array.isArray(value) && value.length > 0) return callback()
							return callback(new Error('附件不能为空'))
						},
						trigger: 'change'
					}
				],
			},
			fileList:[],
			file:[]
	    }
	  },
	  computed: {
		isPersonalCenterActive() {
			const p = this.$route && this.$route.path ? this.$route.path : ''
			return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
		},
		  // 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
		uploadActionUrl() {
			const base = this.baseURL || ''
			const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
			return base + path
		},
		oid() {
           return this.$route.query.oid || ''
		}
	  },
	  mounted() {

	  },
	  methods: {
		  fanhui(){
		  	this.$router.go(-1)  
		  },
		  submitForm(formName) {
		  	this.$refs[formName].validate((valid) => {
		  	  if (valid) {
		  	    // this.DemandAdd(this.ruleForm)
		  		this.setDemandAdd()
		  	  } else {
		  	    console.log('error submit!!')
		  	    return false
		  	  }
		  	})
		  },
		  
		  setDemandAdd(){
			// 提交时以上传组件内部 fileList 为准
			this.ruleForm.file = this.getUploadedFileUrls(this.fileList)
		  	defenseOrId(this.oid,{
		  		content:this.ruleForm.description,
		  		file:this.ruleForm.file
		  	}).then(res=>{
		  		if(res.data.status==200){
		  		    this.$message.success('提交成功');
					setTimeout(()=>{
						this.$router.go(-2)
					},3000)
		  		}else{
					 // this.$message.error(res.data.msg);
				}
		  	})
		  },
		  quxiao(){
			 this.$router.go(-2)
		  },
		  handleExceed(files, fileList) {
		    this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		  },
		 handleRemove(file, fileList) {
		   this.fileList = fileList
		   this.ruleForm.file = this.getUploadedFileUrls(this.fileList)
		   // 移除后让表单立即反映校验结果
		   this.$nextTick(() => this.$refs.ruleForm && this.$refs.ruleForm.validateField('file'))
		 },
		 handleUploadSuccess(response, file, fileList) {
		   this.fileList = fileList
		   this.ruleForm.file = this.getUploadedFileUrls(this.fileList)
		   // 上传成功后清除/更新“附件必填”状态
		   this.$nextTick(() => this.$refs.ruleForm && this.$refs.ruleForm.validateField('file'))
		 },
		 getUploadedFileUrls(list) {
		   if (!Array.isArray(list)) return []
		   return list
			 .map((item) => item && item.response && item.response.data)
			 .filter((url) => Boolean(url))
		 },
		 getUploadUrlFromResponse(response) {
		   if (!response) return ''
		   if (typeof response === 'string') return response
		   const level1 = response.data || {}
		   const level2 = level1.data || {}
		   const candidate =
		 	level2.url ||
		 	level2.file ||
		 	level1.url ||
		 	level1.file ||
		 	response.url ||
		 	response.file ||
		 	''
		   if (Array.isArray(candidate)) return candidate[0] || ''
		   if (typeof candidate === 'string') return candidate
		   if (Array.isArray(level1)) return level1[0] || ''
		   if (typeof level1 === 'string') return level1
		   return ''
		 },
		 beforeRemove(file, fileList) {
		   return this.$confirm(`确定移除 ${file.name}？`)
		 },
	  },
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.submit{
		width:1200px;
		margin:0 auto;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
	}
	.submit textarea{
		height:300px;
	}
	.fbfooter{
		margin-top:80px;
		width:100%;
		display:flex;
		justify-content:center;
		align-items: center;
	}
	.fbfooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		 text-align: center;
		 line-height:40px;
		 font-weight: 500;
		 font-size: 16px;
		 color: #1E3A8A;
		cursor:pointer;
		margin-right:32px;
	}
	.fbfooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px 8px 8px 8px;
		 text-align: center;
		 line-height:40px;
		 font-weight: 500;
		 font-size: 16px;
		 color: #fff;
		 cursor:pointer;
	}
</style>